module.exports = __webpack_public_path__ + "img/galeria-ornamentais-5.489a5f57.jpg";